/* global  */ // tUrl等のグローバル変数を宣言する
import './_smoothScroll' // スムーズスクロール
import Swiper from 'swiper' // Swiper
import autoScroll from './functions/_autoScroll'
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,.' + accBtn + '-close,#' + accBtn + ' a,#overlay').on('click', function() {
    $('#' + accBtn + ',#' + accBtn + '-open,.' + accBtn + '-close,#overlay').toggleClass('is-active')
  })

  /*
        ######  ##      ## #### ########  ######## ########
       ##    ## ##  ##  ##  ##  ##     ## ##       ##     ##
       ##       ##  ##  ##  ##  ##     ## ##       ##     ##
        ######  ##  ##  ##  ##  ########  ######   ########
             ## ##  ##  ##  ##  ##        ##       ##   ##
       ##    ## ##  ##  ##  ##  ##        ##       ##    ##
        ######   ###  ###  #### ##        ######## ##     ##
*/
  if ($('#h-inter-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const headerSwiper = new Swiper('#h-inter-slide', {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 4, //表示数変更
      spaceBetween: 20, //スライド同士の間隔を空ける
      navigation: {
        nextEl: '.swiper-button-next--h-inter', // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--h-inter' // 次のページボタンを呼び出す要素
      },
      breakpoints: {
        // 指定px以上でオプション切り替え
        769: {}
      }
    })
  }

  /*
               ########  #######  ########          ##     ## ##     ##
                  ##    ##     ## ##     ##         ###   ### ##     ##
                  ##    ##     ## ##     ##         #### #### ##     ##
       #######    ##    ##     ## ########  ####### ## ### ## ##     ##
                  ##    ##     ## ##                ##     ##  ##   ##
                  ##    ##     ## ##                ##     ##   ## ##
                  ##     #######  ##                ##     ##    ###
*/
  if ($('#top-mv-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const topMvSwiper = new Swiper('#top-mv-slide', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 1000, // アニメ速度
      loop: true, // ループ
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },
      autoplay: {
        // オートオプション
        delay: 3000, // 待機時間
        disableOnInteraction: false // 操作されたらオート解除
      }

      // breakpoints: {
      //   // 指定px以上でオプション切り替え
      //   769: {}
      // }
    })
  }

  /*
               ########  ######## ########   ######   #######  ##    ##
               ##     ## ##       ##     ## ##    ## ##     ## ###   ##
               ##     ## ##       ##     ## ##       ##     ## ####  ##
       ####### ########  ######   ########   ######  ##     ## ## ## ##
               ##        ##       ##   ##         ## ##     ## ##  ####
               ##        ##       ##    ##  ##    ## ##     ## ##   ###
               ##        ######## ##     ##  ######   #######  ##    ##
*/
  if ($('#top-person-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const topPersonSwiper = new Swiper('#top-person-slide', {
      init: false, // 自動で初期化しない（topPersonSwiper.init()で初期化）
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },
      // autoplay: {
      //   // オートオプション
      //   delay: 5000, // 待機時間
      //   disableOnInteraction: false // 操作されたらオート解除
      // },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--top-person', // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
        renderBullet: function(index, className) {
          // bulletsの描画内容を改変
          const targetImage = $('[data-swiper-slide-index="' + index + '"]')
            .find('.swiper-img')
            .attr('src')
          return (
            '<div class="' +
            className +
            '"><img class="swiper-pagination-image" src=" ' +
            targetImage +
            ' " alt="ページ' +
            index +
            '" /></div>'
          )
        }
      },
      navigation: {
        nextEl: '.swiper-button-next--top-person', // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--top-person' // 次のページボタンを呼び出す要素
      },
      breakpoints: {
        // 指定px以上でオプション切り替え
        769: {}
      }
    })
    topPersonSwiper.init()
  }

  /*
               #### ##    ## ########         ##    ##    ###    ##     ##
                ##  ###   ##    ##            ###   ##   ## ##   ##     ##
                ##  ####  ##    ##            ####  ##  ##   ##  ##     ##
       #######  ##  ## ## ##    ##    ####### ## ## ## ##     ## ##     ##
                ##  ##  ####    ##            ##  #### #########  ##   ##
                ##  ##   ###    ##            ##   ### ##     ##   ## ##
               #### ##    ##    ##            ##    ## ##     ##    ###
*/
  if ($('#int-nav-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const intNavSwiper = new Swiper('#int-nav-slide', {
      // init: false, // 自動で初期化しない（int-navSwiper.init()で初期化）
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      // loopAdditionalSlides: 8, //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 2, //表示数変更
      slidesPerGroup: 1, //移動数変更
      // spaceBetween: 25, //スライド同士の間隔を空ける
      // freeMode: true, //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
      // grabCursor: true, // 掴みカーソル
      //    simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
      //    autoHeight: true, // スライドごとに高さを変動させる

      // autoplay: {
      //   // オートオプション
      //   delay: 5000, // 待機時間
      //   disableOnInteraction: false // 操作されたらオート解除
      // },

      navigation: {
        nextEl: '.swiper-button-next--int-nav', // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--int-nav' // 次のページボタンを呼び出す要素
      },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--int-nav', // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true // クリックでジャンプ可能にする
      },
      breakpoints: {
        // 指定px以上でオプション切り替え
        769: {
          slidesPerView: 6, //表示数変更
          spaceBetween: 30, //スライド同士の間隔を空ける
          centeredSlides: true // 中央のスライドを基準にする
        }
      }
    })
  }

  /*
                ######      ###    ##
               ##    ##    ## ##   ##
               ##         ##   ##  ##
       ####### ##   #### ##     ## ##
               ##    ##  ######### ##
               ##    ##  ##     ## ##
                ######   ##     ## ########
*/
  if ($('#gal-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const galSwiper = new Swiper('#gal-slide', {
      // init: false, // 自動で初期化しない（galSwiper.init()で初期化）
      effect: 'fade', // slide,fade,cube,coverflow
      autoHeight: true,
      speed: 500, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },
      navigation: {
        nextEl: '.swiper-button-next--gal', // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--gal' // 次のページボタンを呼び出す要素
      }
    })
    $(document).on('click', '.js-slideTo', function() {
      const slide = $(this).data('slide')
      galSwiper.slideTo(slide, 0)
    })
  }

  /*
           ###          ##    ###    ##     ##
          ## ##         ##   ## ##    ##   ##
        ##     ##       ## ##     ##    ###
        ######### ##    ## #########   ## ##
        ##     ##  ######  ##     ## ##     ##
 */
  $(document).on('click', '.js-globalAjax', function() {
    const url = $(this).attr('href') // 取得先のURL
    const from = $(this).attr('data-ajaxtarget') // 取得する要素
    const to = $(this).attr('data-ajaxtarget') // 書き換える場所
    autoScroll('#hashtag', '#header', true)
    $(to)
      .addClass('is-active')
      .html('<div class="md-loading active"></div>')
    $.ajax({
      url: url,
      dataType: 'html'
    })
      .done(function(data) {
        const outHtml = $($.parseHTML(data)) //parse
        $(to).html(outHtml.find(from)[0].innerHTML)
        // history.replaceState(null, null, url) // URL変更
      })
      .fail(function(data) {})
      .always(function(data) {})

    return false
  })
  $(document).on('click', '.js-globalAjax--reset', function() {
    const to = $(this).attr('data-ajaxtarget') // 書き換える場所
    $(to).removeClass('is-active')
    return false
  })

  /*
            ###          ##    ###    ##     ##
           ## ##         ##   ## ##    ##   ##
         ##     ##       ## ##     ##    ###
         ######### ##    ## #########   ## ##
         ##     ##  ######  ##     ## ##     ##
  */
  $(document).on('click', '.js-reqAjax', function() {
    const url = $(this).attr('href') // 取得先のURL
    const from = $(this).attr('data-ajax-target') // 取得する要素
    const to = $(this).attr('data-ajax-target') // 書き換える場所

    autoScroll('#req-tab', '#header', false)
    $(to)
      .addClass('is-active')
      .html('<div class="md-loading active"></div>')
    $.ajax({
      url: url,
      dataType: 'html'
    })
      .done(function(data) {
        const outHtml = $($.parseHTML(data)) //parse
        $(to).html(outHtml.find(from)[0].innerHTML)
        // history.replaceState(null, null, url) // URL変更
      })
      .fail(function(data) {})
      .always(function(data) {})
    return false
  })

  /*
       ########  #######   ######    ######   ##       ########
          ##    ##     ## ##    ##  ##    ##  ##       ##
          ##    ##     ## ##        ##        ##       ##
          ##    ##     ## ##   #### ##   #### ##       ######
          ##    ##     ## ##    ##  ##    ##  ##       ##
          ##    ##     ## ##    ##  ##    ##  ##       ##
          ##     #######   ######    ######   ######## ########
*/
  // クリックトグル
  $(document).on(' click ', '.js-clickToggle', function() {
    const target = $(this).attr('data-toggle') // 書き換える場所
    $(target).removeClass('is-active')
    $(this).addClass('is-active')
  })

  /*
 ######## ########  ##     ## ##    ## ##    ##  #######
    ##    ##     ## ##     ## ###   ## ##   ##  ##     ##
    ##    ##     ## ##     ## ####  ## ##  ##   ##     ##
    ##    ########  ##     ## ## ## ## #####     #######
    ##    ##   ##   ##     ## ##  #### ##  ##   ##     ##
    ##    ##    ##  ##     ## ##   ### ##   ##  ##     ##
    ##    ##     ##  #######  ##    ## ##    ##  #######
*/
  function trunk8() {
    $('.js-t8.line3').trunk8({
      // 指定要素に行数制限をかける
      lines: 3,
      fill: '...'
    })
    $('.js-t8.line2').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line1').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
  }
  if ($('.js-t8')[0]) {
    // 要素を検出したら実行
    trunk8()
    $(window).on('load resize ', function() {
      trunk8()
    })
  }

  /*
  ######   ######          ##        #######   ######  ##    ##
 ##    ## ##    ##         ##       ##     ## ##    ## ##   ##
 ##       ##               ##       ##     ## ##       ##  ##
  ######  ##       ####### ##       ##     ## ##       #####
       ## ##               ##       ##     ## ##       ##  ##
 ##    ## ##    ##         ##       ##     ## ##    ## ##   ##
  ######   ######          ########  #######   ######  ##    ##
*/
  /**
   * Safariを含めた全ブラウザでスクロールをロックする
   * オーバーレイの状態を基準にONOFFを切り替え
   * scrollLock('html,body', '#overlay')
   *
   * @function scrollLock
   * @param  {String} [selecter='html,body']  固定対象セレクタ
   * @param  {String} [trigger='#overlay']  判定用セレクタ
   * @return {Boolean} false
   */
  let scrollLockTop
  let scrollLockToggle = false
  function scrollLock(selecter = 'html,body', trigger = '#overlay') {
    const dom = $(selecter)
    if (!scrollLockToggle && $(trigger).hasClass('is-active')) {
      // スクロール停止
      scrollLockTop = $(window).scrollTop()
      dom.css({ position: 'fixed', top: -scrollLockTop })
      scrollLockToggle = true
    } else {
      // スクロール停止解除
      dom.css({ position: 'static', top: '0' }).scrollTop(scrollLockTop)
      scrollLockToggle = false
    }
  }

  /*
 ##     ##  #######  ########     ###    ##
 ###   ### ##     ## ##     ##   ## ##   ##
 #### #### ##     ## ##     ##  ##   ##  ##
 ## ### ## ##     ## ##     ## ##     ## ##
 ##     ## ##     ## ##     ## ######### ##
 ##     ## ##     ## ##     ## ##     ## ##
 ##     ##  #######  ########  ##     ## ########
*/
  $(document).on('click ', '.js-modal-open', function() {
    const target = $(this).data('modal')

    $('.js-modal').removeClass('is-active') // 他のモーダルを消す
    $('.js-modal--' + target).addClass('is-active')
    $('#modalOverlay').addClass('is-active')

    scrollLock('html,body', '#modalOverlay')
  })
  // モーダル撤去
  $(document).on('click ', '.js-modal--close', function() {
    $('.js-modal').removeClass('is-active')
    $('#modalOverlay').removeClass('is-active')

    scrollLock('html,body', '#modalOverlay')
  })

  /*
        ######  ########          ##    ##    ###    ##     ##
       ##    ## ##     ##         ###   ##   ## ##   ##     ##
       ##       ##     ##         ####  ##  ##   ##  ##     ##
        ######  ########  ####### ## ## ## ##     ## ##     ##
             ## ##                ##  #### #########  ##   ##
       ##    ## ##                ##   ### ##     ##   ## ##
        ######  ##                ##    ## ##     ##    ###
*/
  $(document).on('click', '.js-spNav-btn', function() {
    const select = $(this)
    if (!select.hasClass('is-active')) {
      $('.footer-spNav__close')
      // 選んだメニューを開く
      $('.js-spNav').removeClass('is-active') // SPメニューをすべて消す
      select.addClass('is-active')
      const target = select.data('nav')
      $('.js-spNav--' + target).addClass('is-active')
      setSPNavCloseBtnPos($('.js-spNav--' + target))
      $('#overlay').addClass('is-active')
      scrollLockToggle = false
    } else {
      // 選んだメニューを閉じる
      $('.js-spNav').removeClass('is-active') // SPメニューをすべて消す
      $('#overlay').removeClass('is-active')
    }
    scrollLock('html,body', '#overlay')
  })
  // 背景クリックによる撤去
  $(document).on('click ', '#overlay', function() {
    $('.js-spNav').removeClass('is-active') // SPメニューをすべて消す
    $('#overlay').removeClass('is-active')
    scrollLock('html,body', '#overlay')
  })

  function setSPNavCloseBtnPos(obj) {
    const closeBtn = obj.children('.footer-spNav__close')
    const parentHeight = obj.outerHeight()
    closeBtn.css('bottom', parentHeight + 'px')
  }

  /*
        ######           ######   #######  ##     ## ##    ## ########
       ##    ##         ##    ## ##     ## ##     ## ###   ##    ##
       ##               ##       ##     ## ##     ## ####  ##    ##
       ##       ####### ##       ##     ## ##     ## ## ## ##    ##
       ##               ##       ##     ## ##     ## ##  ####    ##
       ##    ##         ##    ## ##     ## ##     ## ##   ###    ##
        ######           ######   #######   #######  ##    ##    ##
*/
  $(document).on('click', '.js-clickCount', function() {
    $(this).removeClass('js-clickCount')
    const postID = $(this).data('postid')
    $.ajax({
      url: './',
      type: 'POST',
      data: {
        postID: postID
      }
    })
      .done((data) => {
        // Ajaxリクエストが成功
      })
      .fail((data) => {
        // Ajaxリクエストが失敗
      })
      .always((data) => {
        // 成功・失敗どちらでも発動
      })
  })
})
